import axios from 'axios'

// const API = axios.create({ baseURL: 'http://localhost:5000'})
const API = axios.create({ baseURL: process.env.REACT_APP_API})

API.interceptors.request.use((req) => {
    if(localStorage.getItem('profile')) {
        req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`
    }

    return req
})

// export const fetchInvoices =() => API.get('/invoices')
export const fetchInvoice =(id) => API.get(`/invoices/${id}`)
export const addInvoice =( invoice ) => API.post('/invoices', invoice)
export const updateInvoice = (id, updatedInvoice) => API.patch(`/invoices/${id}`, updatedInvoice)
export const deleteInvoice =(id) => API.delete(`/invoices/${id}`)
export const fetchInvoicesByUser = (searchQuery) => API.get(`/invoices?searchQuery=${searchQuery.search}`);

export const fetchClient = (id) => API.get(`/clients/${id}`);
export const fetchClients = (page) => API.get(`/clients?page=${page}`);
export const addClient =( client ) => API.post('/clients', client)
export const updateClient = (id, updatedClient) => API.patch(`/clients/${id}`, updatedClient)
export const deleteClient =(id) => API.delete(`/clients/${id}`)
export const fetchClientsByUser = (searchQuery) => API.get(`/clients/user?searchQuery=${searchQuery.search}`);


export const signIn =(formData)=> API.post('/users/signin', formData)
export const fetchMe = () => API.get('/users/me')
export const forgot = (formData) => API.post('/users/forgot', formData);
export const reset = (formData) => API.post('/users/reset', formData);

export const fetchUsers = () => API.get('/users')
export const createUser = (userData) => API.post('/users', userData)
export const updateUser = (id, userData) => API.patch(`/users/${id}`, userData)
export const deleteUser = (id) => API.delete(`/users/${id}`)

export const deleteCampaign = (id) => API.delete(`/campaigns/${id}`)
export const deleteCampaignsBulk = (ids) => API.delete('/campaigns/bulk', { data: { ids } })

export const fetchRhDashboardStats = ({ page = 1, limit = 5, month, year } = {}) =>
  API.get(`/campaigns/dashboard/stats?page=${page}&limit=${limit}&month=${month}&year=${year}`)

export const fetchRhCampaign = (id) => API.get(`/campaigns/${id}`)

export const previewRhExcel = (formData) =>
  API.post('/campaigns/preview', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

export const generateRhCampaign = (formData) =>
  API.post('/campaigns/generate', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

export const previewRhInvoicePdf = (body) =>
  API.post('/campaigns/preview-pdf', body, { responseType: 'blob' })

export const sendRhCampaignEmails = (id, body = {}) =>
  API.post(`/campaigns/${id}/send-emails`, body)

export const sendRhSingleInvoiceEmail = (id, invoiceId) =>
  API.post(`/campaigns/${id}/send-email/${invoiceId}`)

export const downloadRhInvoicePdf = (campaignId, invoiceId) =>
  API.get(`/campaigns/${campaignId}/pdf/${invoiceId}`, { responseType: 'blob' })

export const previewBulkExport = ({ month, year }) =>
  API.get(`/campaigns/bulk-export/preview?month=${month}&year=${year}`)

export const sendBulkExport = ({ month, year, email }) =>
  API.post('/campaigns/bulk-export/send', { month, year, email })

export const downloadBulkExportZip = ({ month, year, part }) => {
  const partQuery = part ? `&part=${part}` : ''
  return API.get(`/campaigns/bulk-export/download?month=${month}&year=${year}${partQuery}`, {
    responseType: 'blob',
  })
}

export const previewVirementExport = ({ month, year }) =>
  API.get(`/campaigns/virement/preview?month=${month}&year=${year}`)

export const downloadVirementExport = ({ month, year, reference }) => {
  const refQuery = reference ? `&reference=${encodeURIComponent(reference)}` : ''
  return API.get(`/campaigns/virement/download?month=${month}&year=${year}${refQuery}`, {
    responseType: 'blob',
  })
}

export const fetchCorporateDashboard = ({
  page = 1,
  limit = 10,
  month,
  year,
  errorsOnly = false,
  periodStart = '',
  periodEnd = '',
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    errorsOnly: errorsOnly ? '1' : '0',
  })
  if (periodStart && periodEnd) {
    params.set('periodStart', periodStart)
    params.set('periodEnd', periodEnd)
  } else {
    params.set('month', String(month))
    params.set('year', String(year))
  }
  return API.get(`/corporate/campaigns/dashboard/stats?${params}`)
}

export const fetchCorporateClients = ({ search = '', page = 1, limit = 10 } = {}) =>
  API.get(`/corporate/clients?search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`)

export const fetchCorporateClient = (id, { page = 1, limit = 10, status = '' } = {}) => {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) })
  if (status) params.set('status', status)
  return API.get(`/corporate/clients/${id}?${params}`)
}

export const createCorporateClient = (data) => API.post('/corporate/clients', data)

export const updateCorporateClient = (id, data) => API.patch(`/corporate/clients/${id}`, data)

export const deleteCorporateClient = (id) => API.delete(`/corporate/clients/${id}`)

export const deleteCorporateCampaign = (id) => API.delete(`/corporate/campaigns/${id}`)

export const previewCorporateBatch = (formData) =>
  API.post('/corporate/campaigns/preview', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

export const generateCorporateCampaign = (formData) =>
  API.post('/corporate/campaigns/generate', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

export const fetchCorporateCampaign = (id) => API.get(`/corporate/campaigns/${id}`)

export const sendCorporateCampaignEmails = (id, body = {}) =>
  API.post(`/corporate/campaigns/${id}/send-emails`, body)

export const sendSingleCorporateEmail = (id, documentId) =>
  API.post(`/corporate/campaigns/${id}/send-email/${documentId}`)

export const downloadCorporatePdf = (campaignId, documentId) =>
  API.get(`/corporate/campaigns/${campaignId}/pdf/${documentId}`, { responseType: 'blob' })

export const fetchCoaches = ({ search = '', page = 1, limit = 10 } = {}) =>
  API.get(`/coaches?search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`)
export const fetchCoach = (id, { page = 1, limit = 10 } = {}) =>
  API.get(`/coaches/${id}?page=${page}&limit=${limit}`)
export const updateCoach = (id, data) => API.patch(`/coaches/${id}`, data)
export const deleteCoach = (id) => API.delete(`/coaches/${id}`)
export const deleteCoachesBulk = (ids) => API.delete('/coaches/bulk', { data: { ids } })

export const fetchProfilesBySearch = (searchQuery) => API.get(`/profiles/search?searchQuery=${searchQuery.search || searchQuery.year || 'none'}`);
export const fetchProfile = (id) => API.get(`/profiles/${id}`)
export const fetchProfiles = () => API.get('/profiles');
export const fetchProfilesByUser = (searchQuery) => API.get(`/profiles?searchQuery=${searchQuery.search}`)
export const createProfile = (newProfile) => API.post('/profiles', newProfile);
export const updateProfile = (id, updatedProfile) => API.patch(`/profiles/${id}`, updatedProfile);
export const deleteProfile = (id) => API.delete(`/profiles/${id}`);